import { Box, Chip, Typography } from "@mui/material";
import dayjs from "dayjs";
import DateSelector from "../Statistic/DateSelector";

type DateRange = [string | null, string | null];

interface CumulativeIncomeGlobalPeriodSettingProps {
  dateRanges: DateRange[];
  onDateChange: (range: DateRange) => void;
  onRemoveDateRange: (index: number) => void;
}

const CumulativeIncomeGlobalPeriodSetting = ({
  dateRanges,
  onDateChange,
  onRemoveDateRange,
}: CumulativeIncomeGlobalPeriodSettingProps) => {
  const formatDateRange = (range: DateRange) => {
    const [startDate, endDate] = range;
    if (startDate && endDate) {
      return `${dayjs(startDate).format("MM/DD/YYYY")} - ${dayjs(endDate).format("MM/DD/YYYY")}`;
    }
    return "";
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Choose global period for Cumulative Income
      </Typography>
      <DateSelector
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
        onDateChange={onDateChange}
        additionalComponents={
          dateRanges.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.75,
                mt: 1,
              }}
            >
              {dateRanges.map((range, index) => (
                <Chip
                  key={`${range[0]}-${range[1]}`}
                  label={formatDateRange(range)}
                  onDelete={() => onRemoveDateRange(index)}
                  size="small"
                />
              ))}
            </Box>
          ) : null
        }
      />
    </Box>
  );
};

export default CumulativeIncomeGlobalPeriodSetting;
